<template>
  <button
    class="cart-selector"
    @click="toggleMiniCart">
    <icon-shopping-cart class="cart-selector__icon" />
    <span class="cart-selector__counter" v-if="counter > 0">
      {{ counter }}
    </span>
  </button>
</template>

<script>
import { useCartStore } from '~/stores/cart';
import IconShoppingCart from '~/assets/icons/IconShoppingCart.svg';

export default {
  setup() {
    const cartStore = useCartStore();

    return { cartStore }
  },
  components: {
    IconShoppingCart,
  },
  computed: {
    currentCart() {
      return this.cartStore.getCurrentCart;
    },
    counter() {
      return this.currentCart?.contents?.productCount ?? 0
    }
  },
  methods: {
    toggleMiniCart() {
      this.cartStore.toggleMiniCart()
    }
  }
}
</script>

<style lang="scss">
@use "~/common/scss/helpers";
@use "~/common/scss/mq";
@use "~/common/scss/variables";

.cart-selector {
  align-items: center;
  display: flex;
  font-size: helpers.px-to-rem(20);
  padding: .1rem .25rem .15rem 0;
  position: relative;
  width: 2.25rem;

  path, circle, rect {
    fill: variables.$colorBlack !important;
  }

  @include mq.mobileOnly() {
    font-size: helpers.px-to-rem(14);
    padding: .3rem .25rem .15rem .35rem;
  }

  &__icon {
    @include mq.mobileOnly() {
      height: 1.25rem;
      margin-left: .5rem;
    }
    color: #{variables.$colorContrast};
    transition: color .25s;
  
    &:hover {
      color: var(--color-orange);
      cursor: pointer;
    }
  }

  &__counter {
    align-items: center;
    background-color: var(--color-orange);
    border-radius: 50%;
    display: flex;
    font-size: helpers.px-to-rem(7);
    color: #fff;
    height: helpers.px-to-rem(12);
    justify-content: center;
    position: absolute;
    right: -.5em;
    top: -.25em;
    width: helpers.px-to-rem(12);

    @include mq.mobileOnly() {
      font-size: helpers.px-to-rem(6);
      height: helpers.px-to-rem(11);
      width: helpers.px-to-rem(11);
      right: -.2em;
      top: -.1em;
    }
  }
}
</style>
